// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__H2UlW","modalForm":"UpgradeEpcsModal_modalForm__qrcxT","modalFooter":"UpgradeEpcsModal_modalFooter__Aci8P"};